// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__3lZO0","root":"Layout_root__T4Qoe","single_title":"Layout_single_title__GC2AV","single_text":"Layout_single_text__y20Km"};